import { Flex, ScrollArea, Title, Text, Box } from '@mantine/core';
import AttractionCard from '@components/attraction-card';
import { Rank, VoyageVibeResult, VoyageVibeState, AttractionStateInput } from '@generated/graphql';
import classes from './vibe-ranked-attractions.module.css';

interface AttrColumnProps {
  attractionType: Rank | null;
  vibeResults: VoyageVibeResult[];
  updateAttractionInterest: (attractionId: string, interest: number) => void;
  interestStates: Record<string, AttractionStateInput>;
}

function AttrColumn({ attractionType, vibeResults, updateAttractionInterest, interestStates }: AttrColumnProps) {
  const columnItems = vibeResults.filter((attraction) => attraction.type === attractionType?.oaiKey);

  return (
    <Box w="20%" h="100%">
      <Title className={classes.title} order={5} mb="sm">
        {attractionType?.text}
      </Title>
      <ScrollArea type="always" h="calc(100% - 40px)">
        {columnItems.length === 0 ? (
          <Text>(No items found.)</Text>
        ) : (
          columnItems.map((item) => (
            <AttractionCard
              key={item.id}
              attraction={item}
              updateAttractionInterest={updateAttractionInterest}
              interestState={interestStates[item.id]}
            />
          ))
        )}
      </ScrollArea>
    </Box>
  );
}

interface RankedAttractionsProps {
  voyageVibeState: VoyageVibeState | null;
  vibeResults: VoyageVibeResult[];
  updateAttractionInterest: (attractionId: string, interest: number) => void;
  interestStates: Record<string, AttractionStateInput>;
}

function RankedAttractions({
  voyageVibeState,
  vibeResults,
  updateAttractionInterest,
  interestStates,
}: RankedAttractionsProps) {
  const rankedAttractionTypes = voyageVibeState?.ranks;
  if (!rankedAttractionTypes) {
    return <div>You have no Voyage Vibe Attraction Types</div>;
  }
  return (
    <Flex gap="md" direction="row" w="100%" h="100%">
      {rankedAttractionTypes.map((type) => (
        <AttrColumn
          key={type?.id}
          attractionType={type}
          vibeResults={vibeResults}
          updateAttractionInterest={updateAttractionInterest}
          interestStates={interestStates}
        />
      ))}
    </Flex>
  );
}

export default RankedAttractions;
